import { ColumnHelper } from "@tanstack/react-table";
import camelCase from "lodash/camelCase";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./notifications_settings_form.module.scss";
import { NotificationRow } from "./notifications_settings_form.types";
import { NotificationSettingFrequencyCell } from "./parts/notification_setting_frequency_cell";
import { NotificationSettingImportantCell } from "./parts/notification_setting_important_cell";
import { NotificationSettingTypeCell } from "./parts/notification_setting_type_cell";

export const useNotificationColumnsGenerator = (showImportantColumn = false) => {
  const { t } = useTranslation("notificationsSettings");

  return <T extends NotificationRow>(columnHelper: ColumnHelper<T>) => [
    columnHelper.display({
      id: "type",
      header: () => <span className={css.cell}>{t("table.typeHeader")}</span>,
      cell: (info) => {
        const { group, setting } = info.row.original;

        return setting ? (
          <NotificationSettingTypeCell notificationSetting={setting} />
        ) : (
          <Typography className={css.cell} variant="bodyBold">
            {t(`group.${camelCase(group || "")}` as unknown as TemplateStringsArray)}
          </Typography>
        );
      }
    }),
    columnHelper.display({
      id: "frequency",
      header: () => <span className={css.cell}>{t("table.frequencyHeader")}</span>,
      size: 400,
      enableSorting: false,
      cell: (info) => {
        const { setting } = info.row.original;

        return (
          <div className={css.cell}>
            {setting ? <NotificationSettingFrequencyCell notificationSetting={setting} /> : null}
          </div>
        );
      }
    }),
    ...(showImportantColumn
      ? [
          columnHelper.display({
            id: "important",
            header: () => <span className={css.cell}>{t("table.importantHeader")}</span>,
            size: 100,
            enableSorting: false,
            cell: (info) => {
              const { setting } = info.row.original;

              return (
                <div className={css.cell}>
                  {setting ? <NotificationSettingImportantCell notificationSetting={setting} /> : null}
                </div>
              );
            }
          })
        ]
      : [])
  ];
};
